exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slick-slider.\\--swiping .slick-list:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;z-index:9999}", ""]);

// exports
